import { Copy } from '../types/copy';

export const afiCopy: Copy = {
  repairServiceName: 'Dreams Restored Program',
  repairServiceShortName: 'DRP',
  privacyAndSecurityLink: 'https://www.amfam.com/privacy-security',
};
